import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "86",
  height: "86",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-width": "5",
      d: "M43.26 42.84V62.5m0 0-8.183-8.066m8.184 8.066 8.183-8.066m-24.55-4.537c-7.859-5.75-7.859-18.952 0-24.702 8.221-6.016 24.55-1.513 24.55 9.074 7.672-2.026 13.065 1.02 14.321 7.058.987 4.743-1.183 9.023-5.626 11.09"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-width": "5",
      d: "M73.267 78.985a22.6 22.6 0 0 0 5.718-5.718C83 67.467 83 59.31 83 43c0-16.31 0-24.466-4.015-30.267a22.6 22.6 0 0 0-5.718-5.718C67.467 3 59.31 3 43 3 26.69 3 18.534 3 12.733 7.015a22.6 22.6 0 0 0-5.718 5.718M65.23 82.06c-2.55.46-5.514.695-9.054.815M45.825 83 43 83c-4.09 0-7.667 0-10.824-.063m-13.647-1.37c-2.225-.587-4.11-1.415-5.796-2.582a22.6 22.6 0 0 1-5.718-5.718c-.896-1.294-1.592-2.706-2.133-4.3M3.073 54.295C3 51.024 3 47.294 3 43s0-8.024.073-11.294"
    }, null, -1)
  ])))
}
export default { render: render }